module.exports = __webpack_public_path__ + "media/images/seller-guide-nikki-thumb-405a706ba44255dc10bb1a75a4be5dbd.png";